import apiClient from "@/api/api-client";

export const uploadFile = async (formData) => {
  const { data } = await apiClient.post("/upload", formData, {});
  return data;
};
